// extracted by mini-css-extract-plugin
export default {"box":"Wallet_box__EE5UG","container":"Wallet_container__W6F27","flex":"Wallet_flex__Snj-w"};